import { AnalyticsEvent } from '@varo/graphql-schema-types';
import { useEffect } from 'react';
import { parseGQLAnalyticsEvent } from 'services/analytics/helpers/parseGQLAnalyticsEvent';
import { useAnalyticsConfiguration } from 'shared/hooks/analytics/useAnalyticsConfiguration';

export const useLogGQLErrorScreenAnalytics = (
  analytics?: AnalyticsEvent,
  screenName?: string,
  flow_name?: string,
): void => {
  const { segmentClient } = useAnalyticsConfiguration();

  useEffect(() => {
    if (analytics) {
      const { name, properties } = parseGQLAnalyticsEvent(analytics);
      void segmentClient.logScreenEvent(name, {
        ...properties,
        flow_name: flow_name,
        name: screenName,
      });
      void segmentClient.logEvent(name, {
        ...properties,
        flow_name: flow_name,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [analytics, segmentClient]);
};
